export var HTTP_ERRORS_VALUES;
(function (HTTP_ERRORS_VALUES) {
    HTTP_ERRORS_VALUES[HTTP_ERRORS_VALUES["ERROR_403"] = 403] = "ERROR_403";
    HTTP_ERRORS_VALUES[HTTP_ERRORS_VALUES["ERROR_404"] = 404] = "ERROR_404";
    HTTP_ERRORS_VALUES[HTTP_ERRORS_VALUES["ERROR_500"] = 500] = "ERROR_500";
})(HTTP_ERRORS_VALUES || (HTTP_ERRORS_VALUES = {}));
